import React from 'react';
import { FiCheckCircle, FiSmartphone } from 'react-icons/fi';

const RegisterSuccess = () => (
  <div style={S.page}>
    <div style={S.card}>
      <img src="/logo.png" alt="LifeChiAI" style={S.logo} />
      <div style={S.iconWrap}>
        <FiCheckCircle size={52} color="#27ae60" />
      </div>
      <h1 style={S.heading}>Application received</h1>
      <p style={S.body}>
        Our team will review your application. You will receive an email
        notification once your account is approved.
      </p>
      <div style={S.appSection}>
        <div style={S.appLabel}>
          <FiSmartphone size={14} style={{ marginRight: 6 }} />
          Download the LifeChiAI app
        </div>
        <div style={S.appBtns}>
          <button
            type="button"
            style={S.storeBtn}
            disabled
          >
            App Store
          </button>
          <button
            type="button"
            style={{ ...S.storeBtn, background: '#1a1a2e' }}
            disabled
          >
            Play Store
          </button>
        </div>
      </div>
      <div style={S.footer}>
        <a href="/login" style={S.link}>Back to Login</a>
      </div>
    </div>
  </div>
);

const S = {
  page:       { minHeight: '100vh', background: '#f5f8f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: "'Open Sans', sans-serif" },
  card:       { background: '#fff', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '48px 40px', width: '100%', maxWidth: '420px', textAlign: 'center' },
  logo:       { height: '36px', display: 'block', margin: '0 auto 28px' },
  iconWrap:   { marginBottom: '20px' },
  heading:    { fontFamily: "'Raleway', sans-serif", fontSize: '22px', fontWeight: '700', color: '#1a1a2e', margin: '0 0 12px' },
  body:       { fontSize: '14px', color: '#555', lineHeight: '1.7', margin: '0 0 28px' },
  appSection: { background: '#f9faf7', borderRadius: '10px', padding: '20px', marginBottom: '24px', border: '1px solid #e8f0e8' },
  appLabel:   { display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', color: '#666', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px', fontFamily: "'Raleway', sans-serif" },
  appBtns:    { display: 'flex', gap: '10px', justifyContent: 'center' },
  storeBtn:   { padding: '10px 22px', background: '#4a8f82', color: '#fff', borderRadius: '8px', border: 'none', cursor: 'not-allowed', opacity: '0.6', fontSize: '13px', fontWeight: '700', fontFamily: "'Raleway', sans-serif" },
  footer:     { marginTop: '8px' },
  link:       { color: '#4a8f82', fontSize: '13px', fontWeight: '700', textDecoration: 'none' },
};

export default RegisterSuccess;
